<template>
 <v-container fluid>
      <div class="batch-header">
        <v-row>
          <v-col cols="6">
            <v-text-field hide-details="auto">
              <span class="input-label" slot="prepend">New Batch Name:</span>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select :items="categoryItems" hide-details="auto">
              <span class="input-label" slot="prepend">Category:</span>
            </v-select>
          </v-col>
        </v-row>
      </div> 
      <div class="batch-middle-section">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          class="batch-elevation"
        >
          <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.delete">
                  <td>
                    <div class="select-cust">
                       <v-select
                          :items="itemsubject"
                          value="Subject 1"
                        ></v-select>
                    </div>
                  </td>
                  <td>
                    <v-btn text class="delete-btn">{{ item.delete }}</v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
        </v-data-table> 
      </div>  
      <v-row>
        <v-col cols="12">
          <div class="create-subject">
            <div class="circle-icon">
                <v-icon>mdi-plus-circle</v-icon> 
                <span>Subject</span>
            </div>
          </div>
        </v-col>  
      </v-row>
      <v-row class="batch-footer-btn">
        <v-col cols="12">
            <div class="pull-right">
              <v-btn class="right-btn cust-btn" color="primary">Save Changes</v-btn>
              <v-btn @click="onClose({status:false})" class="right-btn cust-btn" color="primary">Cancel</v-btn>
            </div>
        </v-col>  
      </v-row>
 </v-container>
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
export default {
 name: 'DuplicateBatch',   
 props:['onClose'],
  data () {
    
     return {
        categoryItems: ['Data type1', 'Data type2', 'Data type3', 'Data type4'],
        itemsubject: ['Subject 1', 'Subject 2', 'Subject 3', 'Subject 4'],
        headers: [
              {
                text: 'Subjects',
                align: 'center',
                sortable: false,
                value: 'subject',
              },
              { text: '', 
                align: 'center',
                sortable: false,
                value: '' 
              }
            ],
            items: [
              {
                delete: 'Delete Subject'
              },
              {
                delete: 'Delete Subject'
              },
               {
                delete: 'Delete Subject'
              },
               {
                delete: 'Delete Subject'
              }
            ],
        }
  }  
}
</script>